module.exports = __webpack_public_path__ + "img/Group 5.d91fabcf.svg";